import { createCardExtension, homePlugin } from '@backstage/plugin-home';
import { InternalToolsContentProps } from './InternalTools';

export const HomepagePavedPathsCard = homePlugin.provide(
  createCardExtension({
    name: 'HomePagePavedPaths',
    title: 'Paved Paths',
    components: () => import('./PavedPaths'),
    description: 'Shows a list of Paved Path solutions',
    layout: {
      height: { minRows: 4 },
      width: { minColumns: 3 },
    },
  }),
);

export const HomepageAddYourServiceCard = homePlugin.provide(
  createCardExtension({
    name: 'HomePageAddYourService',
    title: 'Catalog - Add your Services and Applications here!',
    components: () => import('./AddYourService'),
    description: 'Centralized software catalog',
    layout: {
      height: { minRows: 5 },
      width: { minColumns: 4 },
    },
  }),
);

export const HomepageInternalToolsCard = homePlugin.provide(
  createCardExtension<InternalToolsContentProps>({
    name: 'HomePageInternalTools',
    title: 'Tools - Plugins Developed by RDC Teams',
    components: () => import('./InternalTools'),
    description: 'List of plugins developed by RDC Teams',
    layout: {
      height: { minRows: 4 },
    },
  }),
);

export const HomepageGetHelpCard = homePlugin.provide(
  createCardExtension({
    name: 'HomePageGetHelp',
    title: 'Where to Get Help',
    components: () => import('./GetHelp'),
    description: 'Slack support channels for common tools and topics',
    layout: {
      height: { minRows: 4 },
      width: { minColumns: 3 },
    },
  }),
);
